import { AxiosResponse } from "axios"
import { coreAxios } from "./axios"

export function getAuths(params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/auths`, {
        params: params
    })
}

export function getRsUserAuths(userId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/auths/rs-user`, {
        params: {
            ...params,
            userId: userId
        }
    })
}


export function updateAuths(authIds: number[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/auths`, authIds, {
        params: params
    })
}
